module.exports = __webpack_public_path__ + "1bbedd8279d190d83af47e41bcc5c2d9.png";